
import { BrowserRouter, useRoutes } from 'react-router-dom';
import routes from './router/config';

function AppRoutes() {
  const routing = useRoutes(routes);
  return routing;
}

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}
